import { render, staticRenderFns } from "./certidoes.vue?vue&type=template&id=25ff33e1&scoped=true&"
import script from "./certidoes.vue?vue&type=script&lang=js&"
export * from "./certidoes.vue?vue&type=script&lang=js&"
import style0 from "./certidoes.vue?vue&type=style&index=0&id=25ff33e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ff33e1",
  null
  
)

export default component.exports